import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionCheckComponent } from './permission-check/permission-check.component';
import { TranslocoModule } from '@jsverse/transloco';
import { OpeningTimesComponent } from './opening-times/opening-times.component';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxListModule,
  DxRadioGroupModule,
  DxTooltipModule,
  DxTreeViewModule,
  DxValidatorModule,
} from 'devextreme-angular';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    DxRadioGroupModule,
    DxCheckBoxModule,
    DxValidatorModule,
    DxDateBoxModule,
    DxButtonModule,
    DxDropDownBoxModule,
    DxListModule,
    DxTreeViewModule,
    DxTooltipModule,
  ],
  declarations: [PermissionCheckComponent, OpeningTimesComponent],
  exports: [PermissionCheckComponent, OpeningTimesComponent],
})
export class SharedFeatureModule {}
